export default "__VITE_ASSET__DdVT3WFS__"